
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tiktok-fashion-index",
      function () {
        return require("private-next-pages/tiktok-fashion-index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tiktok-fashion-index"])
      });
    }
  